import SortIcon from "../../../global/components/SortIcon";
import {
  formatUnixTime,
  formatUTCTime,
  formatYearMonthToLabel,
} from "../../../global/utils/unixToLocalTime";

export const InvoiceColumns = (setParams, params, hideBak) => {
  const logData = JSON.parse(sessionStorage.getItem("userData"));
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  return [
    // {
    //   title: "No",
    //   dataIndex: "InvoiceNo",
    //   key: "InvoiceNo",
    //   sorter: (a, b) => a?.InvoiceNo - b?.InvoiceNo,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="InvoiceNo"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "InvoiceNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "OEM",
    //   dataIndex: "OemName",
    //   key: "OemName",
    //   hidden: [4, 5, 6, 7, 8, 9, 10, 11, 12].includes(logData.role_value),
    //   sorter: (a, b) => a?.OemName - b?.OemName,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OemName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OemName",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Invoice Time",
      dataIndex: "InvoiceTime",
      key: "InvoiceTime",
      width: 320,
      render: (text) => {
        return <div>{text ? formatUTCTime(text) : ""}</div>;
      },
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="InvoiceTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "InvoiceTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Dealer",
      dataIndex: "Dealer",
      hidden: [7, 8, 9].includes(logData.role_value),
      key: "Dealer",
      width: 350,
      sorter: (a, b) => () => {},
      render: (text) => {
        return text ? text : "N/A";
      },
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Month",
      dataIndex: "Month",
      key: "Month",
      width: 250,
      render: (text) => <div>{text ? formatYearMonthToLabel(text) : ""}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Month"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Month",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },

    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
      width: 150,
      render: (text) => {
        return `$ ${text}`;
      },
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Amount"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Amount",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Dealer Discount",
      dataIndex: "Dealer_Discount",
      key: "Dealer_Discount",
      width: 300,
      render: (text) => {
        console.log(typeof text);

        return `${typeof text === "number" ? text + "%" : ""}`;
      },
    },
    {
      title: "Discounted Amount",
      dataIndex: "Amount_with_discount",
      key: "Amount_with_discount",
      width: 300,
      render: (text) => {
        return `$ ${text}`;
      },
    },

    {
      title: "Paid",
      dataIndex: "Paid",
      key: "Paid",
      width: 150,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Paid"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Paid",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },

    {
      title: "Payment Time",
      dataIndex: "PaymentTime",
      key: "PaymentTime",
      width: 250,
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PaymentTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PaymentTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    { title: "", fixed: "right", width: 0, align: "center" },
  ];
};

export const PaymentOrderColumns = (setParams, params) => {
  return [
    // {
    //   title: "Order No",
    //   dataIndex: "OrderNo",
    //   key: "OrderNo",
    //   sorter: (a, b) => a?.OrderNo - b?.OrderNo,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OrderNo"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OrderNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "MAC",
      dataIndex: "Mac",
      key: "Mac",
      width: 120,
      sorter: (a, b) => a?.Mac?.length - b?.Mac?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="Mac"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "Mac",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Order Time",
      dataIndex: "OrderTime",
      key: "OrderTime",
      width: 150,
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.OrderTime) - new Date(b.OrderTime),
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OrderTime"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OrderTime",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Order Item",
      dataIndex: "OrderItem",
      key: "OrderItem",
      width: 120,
      sorter: (a, b) => a?.OrderItem?.length - b?.OrderItem?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OrderItem"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OrderItem",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Order Type",
      dataIndex: "OrderType",
      key: "OrderType",
      width: 120,
      sorter: (a, b) => a?.OrderType?.length - b?.OrderType?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OrderType"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OrderType",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Old License",
      dataIndex: "OldCode",
      key: "OldCode",
      width: 120,
      sorter: (a, b) => a?.OldCode - b?.OldCode,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OldCode"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OldCode",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Old Price",
      dataIndex: "OldPrice",
      key: "OldPrice",
      width: 120,
      render: (text) => {
        return `$ ${text}`;
      },
      sorter: (a, b) => a?.OldPrice - b?.OldPrice,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="OldPrice"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "OldPrice",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "New License",
      dataIndex: "NewCode",
      key: "NewCode",
      width: 120,
      sorter: (a, b) => a?.NewCode - b?.NewCode,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="NewCode"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "NewCode",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "New Price",
      dataIndex: "NewPrice",
      key: "NewPrice",
      width: 120,
      render: (text) => {
        return `$ ${text}`;
      },
      sorter: (a, b) => a?.NewPrice - b?.NewPrice,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="NewPrice"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "NewPrice",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      width: 120,
      render: (text) => {
        return `$ ${text}`;
      },
      sorter: (a, b) => a?.Price - b?.Price,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="Price"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "Price",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },

    // {
    //   title: "Order Name",
    //   dataIndex: "OrderName",
    //   // hidden: hideBak,
    //   key: "OrderName",
    //   sorter: (a, b) => a?.OrderName?.length - b?.OrderName?.length,
    //   render: (text) => {
    //     return text ? text : "N/A";
    //   },
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OrderName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OrderName",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },

    // {
    //   title: "Amount",
    //   dataIndex: "Amount",
    //   key: "Amount",
    //   render: (text) => {
    //     return `$ ${text}`;
    //   },
    //   sorter: (a, b) => a?.Amount?.length - b?.Amount?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="Amount"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "Amount",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
  ];
};

export const OrderItemColumns = (setParams, params) => {
  return [
    {
      title: "Invoice No",
      dataIndex: "ItemNo",
      key: "ItemNo",
      sorter: (a, b) => a?.ItemNo - b?.ItemNo,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="ItemNo"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "ItemNo",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "Customer",
    //   dataIndex: "CustomerName",
    //   // hidden: hideBak,
    //   key: "CustomerName",
    //   sorter: (a, b) => a?.CustomerName?.length - b?.CustomerName?.length,
    //   render: (text) => {
    //     return text ? text : "N/A";
    //   },
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="CustomerName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "CustomerName",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Order Item",
      dataIndex: "CustomerName",
      // hidden: hideBak,
      key: "CustomerName",
      sorter: (a, b) => a?.CustomerName?.length - b?.CustomerName?.length,
      render: (text) => {
        return text ? text : "N/A";
      },
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="CustomerName"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "CustomerName",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "License",
    //   dataIndex: "LicenseName",
    //   key: "LicenseName",
    //   sorter: (a, b) => a?.LicenseName?.length - b?.LicenseName?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="LicenseName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "LicenseName",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      render: (text) => {
        return `$ ${text}`;
      },
      sorter: (a, b) => a?.Price?.length - b?.Price?.length,
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="Price"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "Price",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Paid",
      dataIndex: "CustomerName",
      // hidden: hideBak,
      key: "CustomerName",
      sorter: (a, b) => a?.CustomerName?.length - b?.CustomerName?.length,
      render: (text) => {
        return text ? text : "N/A";
      },
      sortIcon: () => (
        <SortIcon
          sortOrder={params.order}
          columnKey="CustomerName"
          sortBy={params.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...prev,
            sort_by: "CustomerName",
            order: prev.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
    },
  ];
};
